/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 捷克语
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Afin de vous informer lorsque votre précommande est disponible dans notre magasin et de vérifier votre précommande lors du retrait, Xiaomi recueillera 
                        votre nom et votre adresse e-mail,
                        et le code de retrait sera envoyé à cette adresse e-mail.
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        La base juridique de ces activités de traitement de vos données personnelles est leur 
                        nécessité pour l'exécution d'un contrat auquel vous êtes partie.
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Vous pouvez exercer vos droits en matière de protection des données (par exemple, accès, rectification et/ou effacement) via notre plateforme : 
                        <a href="https://privacy.mi.com/support/?locale=fr" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/support/?locale=fr</span>
                        </a>
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Pour plus d'informations sur la manière dont nous traitons vos données, veuillez consulter : 
                        <a href="https://privacy.mi.com/all/fr_FR/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/fr_FR/</span>
                        </a>
                    </span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)